import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const PluginManagementCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PluginManagementCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pluginCategories"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"PluginManagementCategories","document":PluginManagementCategoriesDocument}} as const;
export type PluginManagementCategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PluginManagementCategoriesQuery = (
  { __typename: 'Query' }
  & Pick<Types.Query, 'pluginCategories'>
);

/**
 * __usePluginManagementCategoriesQuery__
 *
 * To run a query within a React component, call `usePluginManagementCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePluginManagementCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePluginManagementCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePluginManagementCategoriesQuery(
  baseOptions?: TrelloQueryHookOptions<
    PluginManagementCategoriesQuery,
    PluginManagementCategoriesQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: PluginManagementCategoriesDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    PluginManagementCategoriesQuery,
    PluginManagementCategoriesQueryVariables
  >(PluginManagementCategoriesDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function usePluginManagementCategoriesLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    PluginManagementCategoriesQuery,
    PluginManagementCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PluginManagementCategoriesQuery,
    PluginManagementCategoriesQueryVariables
  >(PluginManagementCategoriesDocument, options);
}
export function usePluginManagementCategoriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        PluginManagementCategoriesQuery,
        PluginManagementCategoriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PluginManagementCategoriesQuery,
    PluginManagementCategoriesQueryVariables
  >(PluginManagementCategoriesDocument, options);
}
export type PluginManagementCategoriesQueryHookResult = ReturnType<
  typeof usePluginManagementCategoriesQuery
>;
export type PluginManagementCategoriesLazyQueryHookResult = ReturnType<
  typeof usePluginManagementCategoriesLazyQuery
>;
export type PluginManagementCategoriesSuspenseQueryHookResult = ReturnType<
  typeof usePluginManagementCategoriesSuspenseQuery
>;
export type PluginManagementCategoriesQueryResult = Apollo.QueryResult<
  PluginManagementCategoriesQuery,
  PluginManagementCategoriesQueryVariables
>;
